export const NAMESPACE = "translations";
export const LANGUAGES = [
  "bs-Latn-BA",
  "da-DK",
  "de-DE",
  "en-US",
  "es-ES",
  "fr-FR",
  "it-IT",
  "lt-LT",
  "nl-NL",
  "pl-PL",
  "ro-RO",
  "sr-Latn-RS",
  "sv-SE",
  "uk-UA",
] as const;

export type PortalLanguage = (typeof LANGUAGES)[number];
export type LanguageMap<V> = { [K in PortalLanguage]: V };

export const DEFAULT_LANG = "en-US" as const satisfies PortalLanguage;

const LANGUAGES_SET = new Set<string>(LANGUAGES);

export const isPortalLanguage = (lang: string): lang is PortalLanguage => {
  return LANGUAGES_SET.has(lang);
};

export const portalLanguageOrDefault = (lang: string): PortalLanguage => {
  return isPortalLanguage(lang) ? lang : DEFAULT_LANG;
};

// Map locales to simple language codes, for when we want the generic language
// (rather than the specific locale) or to interface with other APIs that want
// these.
export const BASE_LANGUAGES = {
  "bs-Latn-BA": "bs",
  "da-DK": "da",
  "de-DE": "de",
  "en-US": "en",
  "es-ES": "es",
  "fr-FR": "fr",
  "it-IT": "it",
  "lt-LT": "lt",
  "nl-NL": "nl",
  "pl-PL": "pl",
  "ro-RO": "ro",
  "sr-Latn-RS": "sr",
  "sv-SE": "sv",
  "uk-UA": "uk",
} as const satisfies LanguageMap<string>;

export const VESELKA_LANGUAGES = {
  "bs-Latn-BA": "bs-BA",
  "da-DK": "da-DK",
  "de-DE": "de-DE",
  "en-US": "en-US",
  "es-ES": "es-ES",
  "fr-FR": "fr-FR",
  "it-IT": "it-IT",
  "lt-LT": "lt-LT",
  "nl-NL": "nl-NL",
  "pl-PL": "pl-PL",
  "ro-RO": "ro-RO",
  "sr-Latn-RS": "sr-RS",
  "sv-SE": "sv-SE",
  "uk-UA": "uk-UA",
} as const satisfies LanguageMap<string>;
